module.exports = __webpack_public_path__ + "img/1.95bb4644.png";